export default function StepResult({ formData }) {
  return (
    <div className="text-center">
      <h2 className="text-xl font-semibold mb-4">Report is Generated & Delivered!</h2>
      <p>Thank you, <strong>{formData.name}</strong>!</p>
      <p>Your customized report will be delivered to: <strong>{formData.email}</strong></p>
      <p className="mt-4 text-green-600 font-semibold">You're all set.</p>
    </div>
  );
}